var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHobby(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 245,
    viewBox: "0 0 140 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4039 87.7748C21.7084 88.4066 21.147 89.3066 20.1581 89.7848C19.1693 90.263 18.12 90.1418 17.8134 89.51C17.5111 88.8804 18.066 87.9781 19.057 87.5C20.0459 87.0196 21.0952 87.143 21.4039 87.7748Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1946 87.9571V80.9316",
    stroke: "black",
    strokeWidth: 1.6818,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8764 86.3386C26.1809 86.9704 25.626 87.8704 24.6371 88.3508C23.6418 88.8289 22.5925 88.7056 22.2902 88.0738C21.9879 87.4442 22.5428 86.5419 23.5338 86.0638C24.527 85.5835 25.572 85.7089 25.8764 86.3386Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6777 86.5225V79.4971",
    stroke: "black",
    strokeWidth: 1.6818,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8572 80.8189L21.0122 83.0107V80.767L25.8572 78.5752V80.8189Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8572 81.9134L21.0122 84.1052V83.5275L25.8572 81.3379V81.9134Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.834 87.5571C110.136 88.1867 109.577 89.089 108.588 89.5671C107.599 90.0453 106.552 89.922 106.246 89.2924C105.941 88.6606 106.496 87.7605 107.489 87.2802C108.48 86.802 109.529 86.9231 109.834 87.5571Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.63 87.7383V80.7129",
    stroke: "black",
    strokeWidth: 1.6818,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.315 86.1195C114.617 86.7513 114.062 87.6514 113.071 88.1296C112.08 88.6099 111.031 88.4844 110.726 87.8548C110.422 87.223 110.981 86.3229 111.97 85.8448C112.961 85.3666 114.006 85.4877 114.315 86.1195Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.109 86.3038V79.2783",
    stroke: "black",
    strokeWidth: 1.6818,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.288 80.6002L109.443 82.792V80.5504L114.288 78.3564V80.6002Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114.288 81.6949L109.443 83.8867V83.3111L114.288 81.1172V81.6949Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7267 10.1699C70.3183 10.5464 70.3183 11.6044 69.7267 12.537C69.1395 13.4673 68.1808 13.9152 67.5914 13.5409C66.9998 13.1644 66.9998 12.1064 67.5914 11.176C68.1808 10.2456 69.1395 9.79559 69.7267 10.1699Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6507 10.4334L65.9543 4.46387",
    stroke: "black",
    strokeWidth: 1.6818,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7799 6.5842C73.3693 6.96068 73.3693 8.02087 72.7799 8.94909C72.1904 9.87946 71.2361 10.3295 70.6445 9.95303C70.0551 9.57871 70.0551 8.51852 70.6423 7.58814C71.2339 6.65776 72.1883 6.20772 72.7799 6.5842Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7052 6.84847L69.0088 0.878906",
    stroke: "black",
    strokeWidth: 1.6818,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.854 1.90619L66.8896 6.32873L65.7107 4.42254L68.6773 0L69.854 1.90619Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4293 2.83665L67.467 7.25919L67.1604 6.7702L70.127 2.34766L70.4293 2.83665Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0434 51.257C8.34567 51.8888 7.79294 52.7889 6.7976 53.267C5.80658 53.7452 4.76158 53.6219 4.45283 52.9901C4.15056 52.3605 4.7076 51.4582 5.69863 50.98C6.68965 50.5019 7.73897 50.6274 8.0434 51.257Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84058 51.4405V44.415",
    stroke: "black",
    strokeWidth: 1.6818,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M122.452 49.5748C123.149 49.6397 123.631 50.5809 123.531 51.6801C123.432 52.777 122.784 53.6144 122.087 53.5495C121.39 53.4867 120.91 52.5434 121.01 51.4464C121.107 50.3473 121.754 49.5099 122.452 49.5748Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M122.503 49.8411L116.488 46.2256",
    stroke: "black",
    strokeWidth: 1.6818,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M3.97125 121.775C4.02739 122.474 3.18318 123.11 2.08636 123.198C0.989545 123.285 0.056817 122.79 0.00283973 122.091C-0.0554558 121.392 0.790908 120.756 1.88557 120.667C2.98239 120.58 3.91727 121.078 3.97125 121.775Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M3.71362 121.873L6.2484 115.321",
    stroke: "black",
    strokeWidth: 1.6818,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0179 17.5848C30.3202 18.2144 29.7631 19.1167 28.7721 19.5948C27.7832 20.0752 26.7339 19.9518 26.4273 19.3179C26.1272 18.6861 26.6799 17.786 27.671 17.3078C28.6598 16.8297 29.7135 16.953 30.0179 17.5848Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8115 17.7678V10.7402",
    stroke: "black",
    strokeWidth: 1.6818,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3626 13.8779C30.5205 13.8779 30.6803 12.8177 30.3867 12.8177C30.0909 12.8177 29.6526 12.8177 29.6526 12.8177V10.5762C29.6526 10.5762 30.1837 10.5762 30.5918 10.5762C31.002 10.5762 30.6566 13.0968 31.3647 13.0968C32.0664 13.0968 32.2046 13.8779 31.3626 13.8779Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M100.74 24.5395C101.377 24.8316 101.523 25.8789 101.066 26.8828C100.608 27.8846 99.7248 28.4623 99.0879 28.1723C98.451 27.8824 98.3063 26.833 98.7619 25.8313C99.2175 24.8295 100.103 24.2496 100.74 24.5395Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M100.7 24.8126L96.2156 19.4121",
    stroke: "black",
    strokeWidth: 1.6818,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4107 20.8295C98.7629 21.3683 98.2102 20.453 97.9835 20.6391C97.7546 20.8273 97.42 21.1086 97.42 21.1086L95.9885 19.3863C95.9885 19.3863 96.3988 19.0466 96.7075 18.7848C97.0227 18.523 98.3678 20.6781 98.9076 20.228C99.4495 19.778 100.056 20.2929 99.4107 20.8295Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4301 240.838C98.2919 244.68 93.5699 245.894 93.2223 240.838C92.8704 235.783 88.0125 165.622 88.0125 165.622H98.4301C98.4301 165.622 98.5704 236.997 98.4301 240.838Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9264 235.96C81.812 239.208 77.8198 240.236 77.5262 235.96C77.2304 231.687 73.126 172.381 73.126 172.381H81.9264C81.9264 172.381 82.0473 232.715 81.9264 235.96Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9596 235.96C43.0784 239.208 47.0662 240.236 47.362 235.96C47.6578 231.687 51.7644 172.381 51.7644 172.381H42.9575C42.9596 172.381 42.8474 232.715 42.9596 235.96Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0329 240.84C29.171 244.68 33.893 245.894 34.2449 240.84C34.5925 235.783 39.4526 165.622 39.4526 165.622H29.0329C29.0329 165.622 28.8968 236.997 29.0329 240.84Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6646 166.985C69.6646 166.985 40.4931 160.345 43.6238 153.356C46.7588 146.37 63.8933 143.522 70.3188 144.245C74.0324 144.665 83.785 140.694 89.1158 141.114C93.0022 141.417 103.919 152.872 104.217 154.683C104.92 158.971 69.6646 166.985 69.6646 166.985Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0977 143.576C50.712 149.913 88.3105 148.26 90.8582 141.479C91.9766 138.498 90.0723 118.895 89.0273 109.334C87.9823 99.7726 88.9496 87.2752 86.6912 84.4668C80.7472 77.0908 72.9896 77.0908 72.9896 77.0908H62.9584C62.9584 77.0908 55.5873 79.023 51.2648 83.5818C43.3668 91.9141 47.983 100.426 48.7883 111.21C50.8869 139.307 43.5935 137.416 47.0977 143.576Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.4223,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5123 106.625C92.1978 109.407 92.349 118.588 93.5278 124.354C94.9636 131.395 106.746 130.713 105.403 115.561C103.14 90.0078 84.261 81.1 80.99 79.5508",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5123 106.625C92.1978 109.407 92.349 118.588 93.5278 124.354C94.9636 131.395 106.746 130.713 105.403 115.561C103.14 90.0078 84.261 81.1 80.99 79.5508",
    stroke: "black",
    strokeWidth: 2.4223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0833 115.957C99.4543 113.2 104.748 108.618 104.748 108.618L110.34 106.956C110.34 106.956 110.949 124.997 100.393 128.381",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0833 115.957C99.4543 113.2 104.748 108.618 104.748 108.618L110.34 106.956C110.34 106.956 110.949 124.997 100.393 128.381",
    stroke: "black",
    strokeWidth: 2.4223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7931 242.578C14.4214 245.235 23.0341 244.718 24.0661 240.164C24.7484 237.165 26.8384 227.651 26.67 228.739L25.2191 221.588L17.008 219.786C17.008 219.786 12.7805 238.266 13.7931 242.578Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6092 160.074C37.0935 168.374 28.8393 189.688 28.4118 221.131C28.3643 224.592 16.5368 221.935 16.5368 221.935C16.5368 221.935 9.64279 168.984 17.72 148.457C20.1597 142.252 25.0155 137.063 31.5489 137.758C39.2936 138.584 40.6344 148.981 38.6092 160.074Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.4223,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1.46044 171.271C-1.14774 170.473 -0.0789921 161.894 4.51771 161.152C7.54908 160.663 17.157 159.179 16.0624 159.278L23.0902 161.184L24.3598 169.515C24.3619 169.515 5.6901 172.565 1.46044 171.271Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2078 151.733C76.8456 152.72 55.0906 159.611 23.7535 158.028C20.3011 157.854 22.1947 169.85 22.1947 169.85C22.1947 169.85 74.4857 180.134 95.4419 173.368C101.772 171.323 107.254 166.799 106.978 160.222C106.654 152.424 96.3875 150.414 85.2078 151.733Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.4223,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1145 71.3878L72.9915 77.0912C72.9915 77.0912 72.5165 81.2844 68.0666 81.2844C63.6145 81.2844 62.9603 77.0912 62.9603 77.0912L63.0618 71.9482C63.0618 71.9482 60.0002 70.8491 58.3917 67.3266C56.971 64.2153 55.2265 55.2533 55.1163 49.4764C54.9674 42.1999 65.3267 42.6132 65.3267 42.6132C65.3267 42.6132 76.4287 41.5855 78.1301 47.7433C79.3133 52.0316 78.6569 63.6614 77.4262 67.3288C76.4136 70.3276 73.1145 71.3878 73.1145 71.3878Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.4223,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M57.21 62.1555C57.21 62.1555 56.8559 63.3347 55.4417 62.9517C54.699 62.7505 53.6821 61.1083 53.6777 59.1198C53.6713 55.8008 56.3809 54.7297 57.21 57.2439",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M57.21 62.1555C57.21 62.1555 56.8559 63.3347 55.4417 62.9517C54.699 62.7505 53.6821 61.1083 53.6777 59.1198C53.6713 55.8008 56.3809 54.7297 57.21 57.2439",
    stroke: "black",
    strokeWidth: 2.4223,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9971 62.1555C77.9971 62.1555 78.7506 63.2481 79.7589 62.9257C80.4908 62.6942 81.5229 61.1104 81.525 59.1198C81.5358 55.8008 78.8218 54.7297 77.9971 57.2439",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9971 62.1555C77.9971 62.1555 78.7506 63.2481 79.7589 62.9257C80.4908 62.6942 81.5229 61.1104 81.525 59.1198C81.5358 55.8008 78.8218 54.7297 77.9971 57.2439",
    stroke: "black",
    strokeWidth: 2.4223,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M73.981 71.0107C71.5844 71.6793 65.3381 71.5755 65.3381 71.5755C65.3381 71.5755 68.2162 73.8841 69.5095 73.9814C70.805 74.0788 73.981 71.0107 73.981 71.0107Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8633 35.9055C55.452 36.2906 53.2432 41.6024 51.8031 44.9907C49.8081 49.6837 55.7715 56.7546 55.7715 56.7546C55.7715 56.7546 56.6935 59.1325 57.4664 59.1216C58.235 59.1108 57.339 51.2978 59.2995 50.1013C65.0534 52.8708 72.8974 51.6743 74.5966 46.4317C76.298 41.1913 76.6326 37.7835 73.0723 36.0786C68.5231 33.8998 62.0674 35.5441 58.8633 35.9055Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1154 37.7822C77.8661 36.4299 82.8212 40.1125 82.832 45.4286C82.8449 49.6218 80.6125 54.0227 79.1723 57.2466C78.4037 58.9689 77.8445 59.7997 77.4235 59.8214C76.2036 59.8863 78.3843 49.1913 72.8052 47.0471C67.2326 44.9029 72.3669 39.1345 75.1154 37.7822Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8479 113.967C63.7983 111.472 77.5884 104.895 77.5884 104.895C77.5884 104.895 83.2928 107.863 87.4296 117.784C91.5729 127.708 91.7845 138.074 84.0657 141.307C79.5381 143.204 75.2199 142.631 70.1547 144.602C65.0852 146.58 65.2363 157.18 53.5772 162.063C41.4949 167.126 29.1255 158.311 23.6306 145.139C18.1314 131.966 22.1193 118.134 32.3728 113.841C42.9761 109.397 50.602 117.002 57.8479 113.967Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M54.999 111.244C60.9537 108.751 61.7008 104.549 66.2262 102.652C73.945 99.417 80.8023 105.995 84.9391 115.915C89.0824 125.838 88.9377 135.347 81.2147 138.582C76.6892 140.479 71.1835 137.883 66.1161 139.858C61.0466 141.834 61.0833 153.928 49.4199 158.816C39.1707 163.109 27.7361 155.356 22.2412 142.182C16.7485 129.01 19.2703 115.409 29.5195 111.114C40.1315 106.667 47.7595 114.279 54.999 111.244Z",
    fill: "#00C385",
    stroke: "black",
    strokeWidth: 2.4223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8691 117.939C52.2961 119.852 50.1413 125.116 52.0543 129.697C53.9651 134.275 59.216 136.437 63.7868 134.522C68.3533 132.609 70.5124 127.343 68.5994 122.764C66.6886 118.184 61.4377 116.024 56.8691 117.939Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.4223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0879 120.865C55.13 122.103 53.7352 125.508 54.9724 128.475C56.2095 131.434 59.6058 132.834 62.5659 131.597C65.5217 130.357 66.9165 126.951 65.6793 123.985C64.4421 121.025 61.0416 119.625 58.0879 120.865Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8052 125.967L47.5052 139.624L51.357 138.01L45.657 124.353L41.8052 125.967Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.4223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3687 136.203L49.44 136.379C49.6429 136.855 49.4076 137.419 48.9304 137.623C48.4554 137.822 47.8898 137.59 47.689 137.112L47.6199 136.935C47.4148 136.456 47.6479 135.892 48.1251 135.693C48.6066 135.496 49.1679 135.725 49.3687 136.203Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M48.296 133.148C48.4968 133.626 48.2658 134.193 47.7843 134.392L47.6116 134.466C47.1345 134.665 46.5709 134.433 46.3723 133.957C46.1693 133.479 46.4025 132.915 46.8797 132.711L47.0546 132.638C47.5339 132.439 48.0974 132.672 48.296 133.148Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8081 130.063C47.2766 131.194 45.5277 131.928 45.0592 130.796C44.5842 129.665 46.3352 128.933 46.8081 130.063Z",
    fill: "black"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5582 127.081C46.0332 128.213 44.2778 128.946 43.8093 127.813C43.3386 126.683 45.0897 125.95 45.5582 127.081Z",
    fill: "black"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M115.119 97.6357L117.602 103.597L64.0958 129.102L60.6218 120.772L115.119 97.6357Z",
    fill: "black"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M117.751 94.5377L115.117 97.636L117.602 103.597L121.884 104.441C121.884 104.441 125.094 101.697 128.858 100.122C132.623 98.5448 136.766 98.2072 136.766 98.2072L140.001 94.2975L137.684 88.7412L132.632 88.2998C132.632 88.2998 129.62 90.5241 125.561 92.2247C121.508 93.9253 117.751 94.5377 117.751 94.5377Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M128.691 88.5425C128.013 88.8281 127.544 89.2543 127.646 89.4988C127.747 89.739 128.375 89.7065 129.056 89.4231C129.731 89.1397 130.198 88.7134 130.098 88.4711C129.995 88.2266 129.366 88.2612 128.691 88.5425Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M129.271 91.2531L128.403 89.1781L129.397 88.7627L130.262 90.8398L129.271 91.2531Z",
    fill: "black"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M120.904 91.7405C120.226 92.0239 119.757 92.448 119.863 92.6925C119.965 92.9348 120.593 92.9002 121.269 92.6189C121.951 92.3333 122.417 91.9092 122.314 91.6669C122.212 91.4224 121.58 91.4549 120.904 91.7405Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M121.486 94.4484L120.62 92.3713L121.615 91.958L122.481 94.0351L121.486 94.4484Z",
    fill: "black"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M124.521 90.2239C123.843 90.5073 123.378 90.9336 123.478 91.1781C123.581 91.4182 124.212 91.3858 124.885 91.1023C125.563 90.8189 126.032 90.3926 125.933 90.1503C125.829 89.9058 125.201 89.9383 124.521 90.2239Z",
    fill: "black"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M125.106 92.934L124.236 90.8547L125.229 90.4414L126.095 92.5164L125.106 92.934Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M133.838 100.879C133.155 101.165 132.527 101.198 132.428 100.957C132.326 100.713 132.79 100.289 133.468 100.003C134.149 99.7219 134.775 99.6873 134.88 99.9274C134.978 100.168 134.511 100.598 133.838 100.879Z",
    fill: "black"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M132.321 98.5619L133.189 100.637L134.177 100.221L133.312 98.1465L132.321 98.5619Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M126.101 104.191C125.423 104.474 124.79 104.504 124.691 104.264C124.589 104.022 125.056 103.596 125.736 103.314C126.409 103.029 127.042 102.994 127.139 103.236C127.241 103.483 126.774 103.907 126.101 104.191Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M124.577 101.868L125.448 103.948L126.436 103.532L125.571 101.455L124.577 101.868Z",
    fill: "black"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M129.715 102.673C129.039 102.959 128.409 102.991 128.307 102.747C128.206 102.504 128.672 102.078 129.352 101.797C130.028 101.513 130.658 101.476 130.758 101.721C130.859 101.963 130.393 102.39 129.715 102.673Z",
    fill: "black"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M129.19 99.9342L128.196 100.351L129.061 102.425L130.055 102.008L129.19 99.9342Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M107.64 101.799C102.072 104.802 102.452 107.544 104.617 110.519C105.427 111.631 107.793 109.532 111.025 108.096C112.571 107.405 112.865 105.644 112.394 104.35C111.604 102.191 110.76 100.12 107.64 101.799Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.4223,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6465 116.751C51.4111 119.073 51.2859 121.403 51.4198 123.735C57.2558 124.213 61.4574 124.261 61.4574 124.261L61.7726 120.591C61.7705 120.589 57.2817 119.157 51.6465 116.751Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2.4223,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9023 124.25C60.9023 124.25 68.9233 128.205 70.5966 127.948C72.2764 127.688 73.941 124.945 72.6715 124.252C71.4041 123.56 65.9373 120.546 65.1363 120.284C63.9336 119.89 61.5047 120.31 60.3604 120.117",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9023 124.25C60.9023 124.25 68.9233 128.205 70.5966 127.948C72.2764 127.688 73.941 124.945 72.6715 124.252C71.4041 123.56 65.9373 120.546 65.1363 120.284C63.9336 119.89 61.5047 120.31 60.3604 120.117",
    stroke: "black",
    strokeWidth: 2.4223,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3572 103.075C51.3572 103.075 47.0628 107.874 47.7365 110.832C48.7404 115.243 54.5225 117.669 54.5225 117.669L53.1385 124.357C53.1385 124.357 35.3217 127.897 32.3724 113.846C28.3457 94.7015 53.1385 77.3057 62.2412 77.3057",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3572 103.075C51.3572 103.075 47.0628 107.874 47.7365 110.832C48.7404 115.243 54.5225 117.669 54.5225 117.669L53.1385 124.357C53.1385 124.357 35.3217 127.897 32.3724 113.846C28.3457 94.7015 53.1385 77.3057 62.2412 77.3057",
    stroke: "black",
    strokeWidth: 2.4223,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHobby);
export default __webpack_public_path__ + "static/media/hobby.9b7056edf800d319418934194b4b38d4.svg";
export { ForwardRef as ReactComponent };